// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
// only allows for postive numbers
// no letters or special characters besides decimal point.
export const isPositiveFloat = (value: string) => {
  const regex = /^\d*\.?\d*$/;
  return regex.test(value) && !value.startsWith('-');
};
